import React, { useState, useEffect } from 'react';
import { Package, MessageCircle, Wrench, ChevronRight, Star } from 'lucide-react';

const primaryColor = 'rgb(0, 10, 117)';

const benefits = [
    { icon: <ChevronRight className="w-4 h-4 flex-shrink-0 mt-0.5" />, text: 'Novo canal de vendas 100% digital' },
    { icon: <ChevronRight className="w-4 h-4 flex-shrink-0 mt-0.5" />, text: 'Maior visibilidade dos seus equipamentos' },
    { icon: <ChevronRight className="w-4 h-4 flex-shrink-0 mt-0.5" />, text: 'Acesso a clientes além da sua região' },
    { icon: <ChevronRight className="w-4 h-4 flex-shrink-0 mt-0.5" />, text: 'Pedidos com pagamento já confirmado automaticamente' },
    { icon: <ChevronRight className="w-4 h-4 flex-shrink-0 mt-0.5" />, text: 'Menos tempo gasto com orçamentos manuais' },
    { icon: <ChevronRight className="w-4 h-4 flex-shrink-0 mt-0.5" />, text: 'Aumento do volume de locações' },
];

const testimonials = [
    {
        name: 'João Silva',
        role: 'Proprietário de Loja',
        comment: 'O Locjah revolucionou meu negócio! Agora consigo gerenciar todos os meus equipamentos de forma digital e alcançar muito mais clientes.',
        rating: 5,
    },
    {
        name: 'Ana Paula',
        role: 'Proprietária de Equipamentos',
        comment: 'Tenho uma pequena loja e o app me permitiu expandir meu alcance. Os clientes encontram meus equipamentos facilmente.',
        rating: 5,
    },
];

const EQUIPMENT_TYPES = [
    'Equipamentos para construção civil',
    'Ferramentas elétricas',
    'Andaimes e escoramentos',
    'Compressores e geradores',
    'Equipamentos de jardinagem',
    'Máquinas de limpeza',
    'Equipamentos para eventos',
    'Outros',
];

const LojistasPage = () => {
    const [form, setForm] = useState({
        name: '',
        whatsapp: '',
        storeName: '',
        equipmentType: '',
        city: '',
    });
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Meta Pixel — carregado apenas nesta página (campanha de tráfego de lojistas)
    useEffect(() => {
        /* eslint-disable */
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        /* eslint-enable */
        window.fbq('init', '1597350088758631');
        window.fbq('track', 'PageView');
    }, []);

    const formatWhatsapp = (value) => {
        const digits = value.replace(/\D/g, '').slice(0, 11);
        if (digits.length === 0) return '';
        if (digits.length <= 2) return `(${digits}`;
        if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
        // Até 10 dígitos: fixo (xx) xxxx-xxxx. Com 11 dígitos: celular (xx) xxxxx-xxxx.
        const split = digits.length <= 10 ? 6 : 7;
        return `(${digits.slice(0, 2)}) ${digits.slice(2, split)}-${digits.slice(split)}`;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const nextValue = name === 'whatsapp' ? formatWhatsapp(value) : value;
        setForm({ ...form, [name]: nextValue });
    };

    const validate = () => {
        const newErrors = {};
        if (!form.name.trim()) newErrors.name = 'Nome é obrigatório';
        if (!form.whatsapp.trim()) {
            newErrors.whatsapp = 'WhatsApp é obrigatório';
        } else {
            const whatsappDigits = form.whatsapp.replace(/\D/g, '').length;
            if (whatsappDigits !== 10 && whatsappDigits !== 11) {
                newErrors.whatsapp = 'Informe um WhatsApp válido: (xx) xxxxx-xxxx ou (xx) xxxx-xxxx';
            }
        }
        if (!form.storeName.trim()) newErrors.storeName = 'Nome da loja é obrigatório';
        if (!form.equipmentType) newErrors.equipmentType = 'Selecione o tipo de equipamento';
        return newErrors;
    };

    const handleSubmit = async () => {
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        setIsSubmitting(true);
        setStatus('');

        try {
            const apiUrl = process.env.REACT_APP_LOJISTAS_API_URL || process.env.REACT_APP_API_URL;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Locjah-Channel': 'web' },
                body: JSON.stringify({
                    name: form.name,
                    whatsapp: form.whatsapp,
                    store_name: form.storeName,
                    equipment_type: form.equipmentType,
                    city: form.city,
                    lead_type: 'lojista',
                }),
            });

            if (response.ok) {
                // Meta Pixel: evento de conversão de lead (campanha de tráfego)
                if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
                    window.fbq('track', 'Lead');
                }
                setStatus('success');
                setForm({ name: '', whatsapp: '', storeName: '', equipmentType: '', city: '' });
            } else {
                setStatus('error');
            }
        } catch {
            setStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-white">
            {/* Meta Pixel — fallback sem JavaScript */}
            <noscript>
                <img
                    height="1"
                    width="1"
                    style={{ display: 'none' }}
                    src="https://www.facebook.com/tr?id=1597350088758631&ev=PageView&noscript=1"
                    alt=""
                />
            </noscript>

            {/* Header */}
            <header className="bg-white shadow-sm sticky top-0 z-50" role="banner">
                <div className="container mx-auto px-4 py-4 flex items-center">
                    <a href="/" className="flex items-center space-x-3" aria-label="Locjah - Página inicial">
                        <picture>
                            <source srcSet={`${process.env.PUBLIC_URL}/logo.webp`} type="image/webp" />
                            <img
                                src={`${process.env.PUBLIC_URL}/logo.png`}
                                alt="Locjah"
                                className="w-10 h-10 rounded-xl"
                                width="40"
                                height="40"
                            />
                        </picture>
                        <span className="text-xl font-bold" style={{ color: primaryColor }}>Locjah</span>
                    </a>
                    <span className="ml-3 px-3 py-1 text-xs font-semibold rounded-full text-white" style={{ backgroundColor: primaryColor }}>
                        Para Lojistas
                    </span>
                </div>
            </header>

            <main>
                {/* Hero + Formulário */}
                <section className="py-12 px-4 bg-gradient-to-br from-blue-50 to-white" aria-labelledby="hero-title">
                    <div className="container mx-auto max-w-6xl">
                        <div className="grid lg:grid-cols-2 gap-12 items-start">

                            {/* Texto */}
                            <div className="lg:pt-4">
                                <span className="inline-block text-sm font-semibold px-3 py-1 rounded-full mb-4 text-white" style={{ backgroundColor: primaryColor }}>
                                    Marketplace de locação de equipamentos
                                </span>
                                <h1 id="hero-title" className="text-4xl lg:text-5xl font-bold mb-4 leading-tight" style={{ color: primaryColor }}>
                                    Transforme seu estoque parado em nova fonte de receita
                                </h1>
                                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                                    Cadastre seus equipamentos no Locjah e receba pedidos com pagamento online já confirmado —
                                    sem ligações, sem orçamentos manuais, sem burocracia.
                                </p>

                                <ul className="space-y-3 mb-8">
                                    {benefits.map((b) => (
                                        <li key={b.text} className="flex items-start gap-2 text-gray-700 font-medium">
                                            <span className="mt-1 text-blue-600">{b.icon}</span>
                                            {b.text}
                                        </li>
                                    ))}
                                </ul>

                                {/* Perfil dos lojistas */}
                                <div className="p-4 rounded-2xl border border-blue-100 bg-blue-50 text-sm text-blue-800">
                                    <strong>Ideal para:</strong> lojas de aluguel, casas de material de construção, lojas de ferramentas e empresas de locação para obras, manutenção e eventos.
                                </div>
                            </div>

                            {/* Formulário */}
                            <div id="cadastro" className="bg-white rounded-3xl shadow-2xl p-8 border border-blue-100">
                                <h2 className="text-2xl font-bold mb-2" style={{ color: primaryColor }}>
                                    Quero cadastrar minha loja
                                </h2>
                                <p className="text-gray-500 text-sm mb-6">Nossa equipe entrará em contato via WhatsApp para te ajudar no cadastro.</p>

                                {status === 'success' ? (
                                    <div className="text-center py-8">
                                        <div className="text-5xl mb-4">🎉</div>
                                        <h3 className="text-xl font-bold mb-2" style={{ color: primaryColor }}>Recebemos seu contato!</h3>
                                        <p className="text-gray-600">Nossa equipe vai entrar em contato pelo WhatsApp em breve para te ajudar a cadastrar seus equipamentos.</p>
                                    </div>
                                ) : (
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-1">Nome completo *</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={form.name}
                                                onChange={handleChange}
                                                placeholder="Seu nome"
                                                className={`w-full px-4 py-3 rounded-xl border text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.name ? 'border-red-400' : 'border-gray-200'}`}
                                            />
                                            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-1">WhatsApp *</label>
                                            <input
                                                type="tel"
                                                name="whatsapp"
                                                inputMode="numeric"
                                                maxLength={15}
                                                value={form.whatsapp}
                                                onChange={handleChange}
                                                placeholder="(11) 99999-9999"
                                                className={`w-full px-4 py-3 rounded-xl border text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.whatsapp ? 'border-red-400' : 'border-gray-200'}`}
                                            />
                                            {errors.whatsapp && <p className="text-red-500 text-xs mt-1">{errors.whatsapp}</p>}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-1">Nome da loja *</label>
                                            <input
                                                type="text"
                                                name="storeName"
                                                value={form.storeName}
                                                onChange={handleChange}
                                                placeholder="Ex: Ferramentas São Paulo"
                                                className={`w-full px-4 py-3 rounded-xl border text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.storeName ? 'border-red-400' : 'border-gray-200'}`}
                                            />
                                            {errors.storeName && <p className="text-red-500 text-xs mt-1">{errors.storeName}</p>}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-1">Tipo de equipamento *</label>
                                            <select
                                                name="equipmentType"
                                                value={form.equipmentType}
                                                onChange={handleChange}
                                                className={`w-full px-4 py-3 rounded-xl border text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white ${errors.equipmentType ? 'border-red-400' : 'border-gray-200'}`}
                                            >
                                                <option value="">Selecione o tipo principal</option>
                                                {EQUIPMENT_TYPES.map((t) => (
                                                    <option key={t} value={t}>{t}</option>
                                                ))}
                                            </select>
                                            {errors.equipmentType && <p className="text-red-500 text-xs mt-1">{errors.equipmentType}</p>}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-1">Cidade / Região <span className="font-normal text-gray-400">(opcional)</span></label>
                                            <input
                                                type="text"
                                                name="city"
                                                value={form.city}
                                                onChange={handleChange}
                                                placeholder="Ex: São Paulo - SP"
                                                className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            />
                                        </div>

                                        <button
                                            type="button"
                                            onClick={handleSubmit}
                                            disabled={isSubmitting}
                                            className="w-full py-4 rounded-xl text-white font-bold text-base shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed mt-2"
                                            style={{ backgroundColor: primaryColor }}
                                        >
                                            {isSubmitting ? 'Enviando...' : 'Quero cadastrar minha loja →'}
                                        </button>

                                        {status === 'error' && (
                                            <p className="text-red-500 text-sm text-center">Erro ao enviar. Tente novamente ou nos chame no WhatsApp.</p>
                                        )}

                                        <p className="text-center text-xs text-gray-400 mt-2">
                                            Sem spam. Entraremos em contato apenas pelo WhatsApp informado.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                {/* Como funciona para lojistas */}
                <section className="py-16 px-4 bg-white" aria-labelledby="como-funciona-lojistas">
                    <div className="container mx-auto max-w-4xl">
                        <h2 id="como-funciona-lojistas" className="text-3xl font-bold text-center mb-12" style={{ color: primaryColor }}>
                            Como funciona para lojistas
                        </h2>
                        <div className="grid md:grid-cols-3 gap-8">
                            {[
                                { icon: <Package className="w-8 h-8 text-white" />, step: '1', title: 'Cadastre seus equipamentos', desc: 'Adicione título, fotos, especificações técnicas, preço por diária e quantidade disponível.' },
                                { icon: <MessageCircle className="w-8 h-8 text-white" />, step: '2', title: 'Receba pedidos pagos', desc: 'Clientes fazem o pedido e pagam online com cartão de crédito. Você recebe a confirmação automaticamente.' },
                                { icon: <Wrench className="w-8 h-8 text-white" />, step: '3', title: 'Combine a logística', desc: 'Alinhe com o cliente a entrega ou retirada do equipamento. Simples, rápido e sem burocracia.' },
                            ].map((item) => (
                                <div key={item.step} className="text-center p-6 rounded-2xl bg-blue-50 hover:shadow-lg transition-shadow">
                                    <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: primaryColor }}>
                                        {item.icon}
                                    </div>
                                    <h3 className="text-lg font-bold mb-2" style={{ color: primaryColor }}>{item.step}. {item.title}</h3>
                                    <p className="text-gray-600 text-sm">{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Depoimentos — somente lojistas */}
                <section className="py-16 px-4 bg-gradient-to-r from-blue-50 to-blue-100" aria-labelledby="depoimentos-lojistas">
                    <div className="container mx-auto max-w-3xl">
                        <h2 id="depoimentos-lojistas" className="text-3xl font-bold text-center mb-10" style={{ color: primaryColor }}>
                            O que lojistas estão dizendo
                        </h2>
                        <div className="grid md:grid-cols-2 gap-6">
                            {testimonials.map((t) => (
                                <div key={t.name} className="bg-white rounded-2xl shadow-lg p-6">
                                    <div className="flex mb-3">
                                        {[...Array(t.rating)].map((_, i) => (
                                            <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                                        ))}
                                    </div>
                                    <p className="text-gray-700 italic mb-4 text-sm leading-relaxed">"{t.comment}"</p>
                                    <div>
                                        <p className="font-bold text-sm" style={{ color: primaryColor }}>{t.name}</p>
                                        <p className="text-gray-400 text-xs">{t.role}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* CTA repetido */}
                        <div className="text-center mt-10">
                            <a
                                href="#cadastro"
                                className="inline-block px-8 py-4 rounded-xl text-white font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                                style={{ backgroundColor: primaryColor }}
                            >
                                Quero cadastrar minha loja →
                            </a>
                        </div>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <footer className="py-8 text-center text-white text-sm" style={{ backgroundColor: primaryColor }}>
                <div className="container mx-auto px-4">
                    <p className="mb-1 font-semibold">Locjah — Marketplace de Locação de Equipamentos</p>
                    <p className="text-blue-200">© 2026 Zenith Tecnologia e Desenvolvimento LTDA. Todos os direitos reservados.</p>
                    <div className="mt-4 flex justify-center gap-6 text-blue-200 text-xs">
                        <a href="/privacy_policy.html" className="hover:text-white transition-colors">Política de Privacidade</a>
                        <a href="/terms_use_v1.html" className="hover:text-white transition-colors">Termos de Uso</a>
                        <a href="/" className="hover:text-white transition-colors">Página principal</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default LojistasPage;
